var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectDefaultImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "179px",
    height: "144px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 3.74 3.01",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .fil0 {fill:#FEFEFE}\r\n    .fil16 {fill:#005F87}\r\n    .fil10 {fill:#354453}\r\n    .fil3 {fill:#3A4553}\r\n    .fil12 {fill:#3A4553}\r\n    .fil4 {fill:#3AA9AE}\r\n    .fil9 {fill:#3AA9AE}\r\n    .fil7 {fill:#BCC0C4}\r\n    .fil5 {fill:#C4337C}\r\n    .fil11 {fill:#EDEEEF}\r\n    .fil2 {fill:#F0F1F2}\r\n    .fil17 {fill:#FAD55A}\r\n    .fil15 {fill:#FC6D39}\r\n    .fil6 {fill:#FD703D}\r\n    .fil14 {fill:#FDFDFD}\r\n    .fil8 {fill:#FFD464}\r\n    .fil13 {fill:#3A4553;fill-rule:nonzero}\r\n    .fil1 {fill:#CDCDCE;fill-rule:nonzero}\r\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2085331829376"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M2.37 0.01l-2.24 0c-0.07,0 -0.12,0.05 -0.12,0.12l0 2.13c0,0.06 0.05,0.11 0.12,0.11l2.24 0c0.07,0 0.12,-0.05 0.12,-0.11l0 -2.13c0,-0.07 -0.05,-0.12 -0.12,-0.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil1",
    d: "M0.13 0.02l0 -0.02 2.24 0 0 0.02 -2.24 0zm-0.13 0.11l0 0 0 -0.01 0 -0.01 0 0 0 -0.01 0 0 0.01 -0.01 0 -0.01 0 0 0 -0.01 0.01 0 0 -0.01 0 0 0.01 -0.01 0 0 0 -0.01 0.01 0 0 -0.01 0.01 0 0 0 0.01 -0.01 0 0 0.01 0 0 -0.01 0.01 0 0 0 0.01 0 0.01 -0.01 0 0 0.01 0 0 0 0.01 0 0.01 0 0 0.02 -0.01 0 0 0 -0.01 0 0 0 -0.01 0 0 0 -0.01 0.01 0 0 -0.01 0 0 0 -0.01 0.01 0 0 -0.01 0 0 0 0 0.01 -0.01 0 0 0 0 0.01 -0.01 0 0 0.01 0 0 -0.01 0.01 0 0 0 0.01 0 0 0 0 -0.01 0.01 0 0.01 0 0 0 0.01 0 0 0 0.01 0 0 -0.02 0zm0.02 2.13l-0.02 0 0 -2.13 0.02 0 0 2.13zm0.11 0.12l0 0 -0.01 0 -0.01 0 0 0 -0.01 0 0 0 -0.01 0 -0.01 0 0 -0.01 -0.01 0 0 0 -0.01 -0.01 0 0 -0.01 0 0 -0.01 -0.01 0 0 0 -0.01 -0.01 0 0 0 -0.01 -0.01 0 0 -0.01 0 0 -0.01 -0.01 0 0 0 -0.01 0 -0.01 -0.01 0 0 -0.01 0 0 0 -0.01 0 -0.01 0 0 0.02 0 0 0 0 0.01 0 0 0 0.01 0 0 0.01 0.01 0 0 0 0.01 0 0 0 0.01 0.01 0 0 0.01 0 0 0.01 0 0 0.01 0 0 0.01 0.01 0 0 0 0 0.01 0 0 0.01 0.01 0 0 0 0.01 0 0 0.01 0.01 0 0 0 0.01 0 0 0 0.01 0 0 0 0.01 0 0 0 0 0.02zm2.24 -0.02l0 0.02 -2.24 0 0 -0.02 2.24 0zm0.13 -0.1l0 0 0 0 0 0.01 0 0.01 0 0 0 0.01 0 0 -0.01 0.01 0 0.01 0 0 0 0.01 -0.01 0 0 0.01 0 0 -0.01 0.01 0 0 -0.01 0.01 0 0 0 0 -0.01 0.01 0 0 -0.01 0 0 0.01 -0.01 0 -0.01 0 0 0.01 -0.01 0 0 0 -0.01 0 -0.01 0 0 0 -0.01 0 -0.01 0 0 -0.02 0.01 0 0.01 0 0 0 0.01 0 0 0 0.01 0 0 0 0.01 -0.01 0 0 0 0 0.01 0 0 -0.01 0.01 0 0 0 0.01 0 0 -0.01 0 0 0.01 -0.01 0 0 0 0 0.01 -0.01 0 0 0 -0.01 0 0 0 -0.01 0.01 0 0 -0.01 0 0 0 -0.01 0 0 0 -0.01 0 0 0 0 0.02 0zm-0.02 -2.13l0.02 0 0 2.13 -0.02 0 0 -2.13zm-0.11 -0.13l0 0 0.01 0 0.01 0 0 0 0.01 0 0.01 0 0 0.01 0.01 0 0 0 0.01 0 0.01 0.01 0 0 0.01 0 0 0.01 0.01 0 0 0 0 0.01 0.01 0 0 0.01 0.01 0 0 0.01 0 0 0.01 0.01 0 0 0 0.01 0 0 0.01 0.01 0 0.01 0 0 0 0.01 0 0 0 0.01 0 0.01 -0.02 0 0 -0.01 0 0 0 -0.01 0 0 0 -0.01 0 -0.01 -0.01 0 0 0 0 -0.01 0 0 0 -0.01 -0.01 0 0 -0.01 0 0 -0.01 -0.01 0 0 0 0 -0.01 -0.01 0 0 -0.01 0 0 0 -0.01 -0.01 0 0 0 0 -0.01 0 0 -0.01 -0.01 0 0 0 -0.01 0 0 0 -0.01 0 -0.01 0 0 0 0 -0.02z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "fil2",
    x: 0.86,
    y: 1.47,
    width: 0.62,
    height: 0.34,
    rx: 0.02,
    ry: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil2",
    x: 0.86,
    y: 1.88,
    width: 0.62,
    height: 0.34,
    rx: 0.02,
    ry: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil2",
    x: 0.19,
    y: 1.47,
    width: 0.62,
    height: 0.34,
    rx: 0.02,
    ry: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil2",
    x: 0.19,
    y: 1.88,
    width: 0.62,
    height: 0.34,
    rx: 0.02,
    ry: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil2",
    x: 0.86,
    y: 0.64,
    width: 0.62,
    height: 0.34,
    rx: 0.02,
    ry: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil2",
    x: 0.86,
    y: 1.06,
    width: 0.62,
    height: 0.34,
    rx: 0.02,
    ry: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M0.13 0.01l2.24 0c0.07,0 0.12,0.05 0.12,0.11l0 0.19 -2.48 0 0 -0.19c0,-0.06 0.06,-0.11 0.12,-0.11z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil4",
    cx: 0.58,
    cy: 0.16,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil5",
    cx: 0.39,
    cy: 0.16,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil6",
    cx: 0.21,
    cy: 0.16,
    r: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil2",
    x: 0.19,
    y: 0.64,
    width: 0.62,
    height: 0.34,
    rx: 0.02,
    ry: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil2",
    x: 0.19,
    y: 1.06,
    width: 0.62,
    height: 0.34,
    rx: 0.02,
    ry: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil7",
    x: 0.03,
    y: 0.55,
    width: 2.46,
    height: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil8",
    cx: 2.34,
    cy: 0.44,
    r: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil9",
    x: 0.2,
    y: 0.47,
    width: 0.35,
    height: 0.04,
    rx: 0.02,
    ry: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil9",
    x: 0.63,
    y: 0.47,
    width: 0.35,
    height: 0.04,
    rx: 0.02,
    ry: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil8",
    x: 1.04,
    y: 0.47,
    width: 0.35,
    height: 0.04,
    rx: 0.02,
    ry: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil10",
    x: 1.26,
    y: 1.48,
    width: 1.01,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil10",
    x: 1.26,
    y: 1.71,
    width: 1.01,
    height: 0.05
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M1.38 0.64l2.23 0c0.07,0 0.12,0.06 0.12,0.12l0 2.12c0,0.06 -0.05,0.12 -0.12,0.12l-2.23 0c-0.07,0 -0.12,-0.06 -0.12,-0.12l0 -2.12c0,-0.06 0.05,-0.12 0.12,-0.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil1",
    d: "M3.61 0.65l-2.23 0 0 -0.02 2.23 0 0 0 0 0.02zm0.13 0.11l-0.02 0 0 0 0 0 0 -0.01 0 -0.01 0 0 0 -0.01 0 0 -0.01 -0.01 0 0 0 -0.01 0 0 -0.01 0 0 -0.01 0 0 0 -0.01 -0.01 0 0 0 0 -0.01 -0.01 0 0 0 -0.01 -0.01 0 0 -0.01 0 0 0 0 -0.01 -0.01 0 0 0 -0.01 0 0 0 -0.01 0 0 0 -0.01 0 -0.01 -0.01 0 -0.02 0.01 0.01 0.01 0 0 0 0.01 0 0.01 0 0 0 0.01 0 0 0 0.01 0.01 0.01 0 0 0 0.01 0.01 0 0 0.01 0 0 0.01 0 0 0.01 0.01 0 0 0.01 0.01 0 0 0 0.01 0.01 0 0 0.01 0 0 0 0.01 0.01 0 0 0.01 0 0.01 0 0 0 0.01 0 0 0 0.01 0 0zm-0.02 2.12l0 -2.12 0.02 0 0 2.12 0 0 -0.02 0zm-0.11 0.13l0 -0.02 0 0 0.01 0 0.01 0 0 -0.01 0.01 0 0 0 0.01 0 0 0 0.01 0 0 0 0 -0.01 0.01 0 0 0 0.01 0 0 -0.01 0.01 0 0 0 0 -0.01 0.01 0 0 -0.01 0 0 0 0 0.01 -0.01 0 0 0 -0.01 0 0 0.01 -0.01 0 0 0 -0.01 0 0 0 -0.01 0 0 0 -0.01 0.02 0 0 0.01 0 0 0 0.01 0 0.01 0 0 0 0.01 -0.01 0 0 0.01 0 0 0 0.01 -0.01 0.01 0 0 0 0.01 -0.01 0 0 0 -0.01 0.01 0 0 0 0.01 -0.01 0 0 0 -0.01 0.01 0 0 -0.01 0 -0.01 0.01 0 0 -0.01 0 0 0 -0.01 0 -0.01 0 0 0.01 -0.01 0 -0.01 0 0 0zm-2.23 -0.02l2.23 0 0 0.02 -2.23 0 0 0 0 -0.02zm-0.13 -0.11l0.02 0 0 0 0 0.01 0 0 0 0.01 0.01 0 0 0.01 0 0 0 0.01 0 0 0 0.01 0.01 0 0 0.01 0 0 0 0 0.01 0.01 0 0 0 0.01 0.01 0 0 0 0.01 0.01 0 0 0 0 0.01 0 0 0.01 0.01 0 0 0 0.01 0 0 0 0.01 0 0 0 0.01 0.01 0 0 0.01 0 0 0.02 -0.01 0 0 0 -0.01 -0.01 -0.01 0 0 0 -0.01 0 0 0 -0.01 0 -0.01 -0.01 0 0 -0.01 0 0 -0.01 -0.01 0 0 0 -0.01 -0.01 0 0 -0.01 -0.01 0 0 0 0 -0.01 -0.01 0 0 0 -0.01 -0.01 -0.01 0 0 0 -0.01 0 0 0 -0.01 -0.01 0 0 -0.01 0 -0.01 0 0 0 -0.01 0 0zm0.02 -2.12l0 2.12 -0.02 0 0 -2.12 0 0 0.02 0zm0.11 -0.13l0 0.02 0 0 -0.01 0.01 0 0 -0.01 0 0 0 -0.01 0 0 0 -0.01 0 0 0 -0.01 0.01 0 0 -0.01 0 0 0 0 0.01 -0.01 0 0 0 -0.01 0.01 0 0 0 0 -0.01 0.01 0 0 0 0.01 0 0 -0.01 0 0 0.01 0 0 0 0.01 0 0 0 0.01 -0.01 0 0 0.01 0 0.01 0 0 -0.02 0 0 -0.01 0 0 0 -0.01 0 0 0.01 -0.01 0 -0.01 0 0 0 -0.01 0 0 0.01 -0.01 0 0 0 -0.01 0.01 0 0 -0.01 0 0 0.01 -0.01 0 0 0.01 -0.01 0 0 0.01 0 0 -0.01 0.01 0 0 0 0.01 -0.01 0.01 0 0 0 0.01 0 0 0 0.01 0 0.01 0 0 0 0.01 -0.01 0 0z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil11",
    d: "M1.27 0.94l0.78 0 0 2.05 -0.65 0c-0.07,0 -0.13,-0.06 -0.13,-0.13l0 -1.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M1.38 0.64l2.23 0c0.07,0 0.12,0.06 0.12,0.12l0 0.18 -2.47 0 0 -0.18c0,-0.06 0.06,-0.12 0.12,-0.12z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil4",
    cx: 1.83,
    cy: 0.79,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil5",
    cx: 1.64,
    cy: 0.79,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil6",
    cx: 1.46,
    cy: 0.79,
    r: 0.06
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "fil12",
    x: 1.46,
    y: 1.6,
    width: 0.46,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil12",
    x: 1.46,
    y: 1.78,
    width: 0.46,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil12",
    x: 1.46,
    y: 1.97,
    width: 0.46,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil12",
    x: 1.46,
    y: 2.15,
    width: 0.46,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil12",
    x: 1.46,
    y: 2.33,
    width: 0.46,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil12",
    x: 1.46,
    y: 2.52,
    width: 0.46,
    height: 0.04
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil13",
    d: "M1.45 1.43l0.01 -0.03c0.02,0.01 0.03,0.01 0.05,0.01 0.01,0 0.02,0 0.02,-0.01 0.01,-0.01 0.01,-0.01 0.01,-0.02 0,-0.01 0,-0.02 -0.01,-0.02 0,-0.01 -0.01,-0.02 -0.03,-0.02 -0.01,-0.01 -0.02,-0.02 -0.02,-0.02 -0.01,-0.01 -0.02,-0.01 -0.03,-0.02 0,-0.01 0,-0.02 0,-0.03 0,-0.02 0.01,-0.04 0.02,-0.05 0.01,-0.02 0.03,-0.02 0.05,-0.02 0.01,0 0.03,0 0.05,0.01l-0.01 0.04c-0.01,-0.01 -0.03,-0.02 -0.04,-0.02 -0.01,0 -0.02,0.01 -0.03,0.01 0,0.01 0,0.01 0,0.02 0,0.01 0,0.02 0,0.02 0.01,0.01 0.02,0.01 0.03,0.02 0.02,0.01 0.03,0.01 0.03,0.02 0.01,0 0.02,0.01 0.02,0.02 0.01,0.01 0.01,0.02 0.01,0.03 0,0.03 -0.01,0.05 -0.02,0.06 -0.01,0.01 -0.03,0.01 -0.05,0.01 -0.02,0 -0.04,0 -0.06,-0.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil13",
    d: "M1.75 1.4l0.01 0.03c-0.01,0 -0.02,0.01 -0.02,0.01 -0.01,0 -0.02,0 -0.04,0 -0.03,0 -0.05,-0.01 -0.07,-0.03 -0.01,-0.02 -0.02,-0.05 -0.02,-0.09 0,-0.04 0.01,-0.07 0.03,-0.1 0.01,-0.01 0.04,-0.02 0.06,-0.02 0.02,0 0.04,0 0.06,0.02l-0.01 0.03c-0.02,-0.01 -0.03,-0.02 -0.05,-0.02 -0.02,0 -0.03,0.01 -0.04,0.03 -0.01,0.02 -0.02,0.04 -0.02,0.06 0,0.03 0.01,0.06 0.02,0.07 0.01,0.01 0.03,0.02 0.04,0.02 0.01,0 0.02,0 0.03,-0.01 0.01,0 0.01,0 0.02,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 2,
    className: "fil13",
    d: "M1.78 1.43l0 -0.03c0.03,0.01 0.04,0.01 0.06,0.01 0.01,0 0.02,0 0.02,-0.01 0.01,-0.01 0.01,-0.01 0.01,-0.02 0,-0.01 0,-0.02 -0.01,-0.02 0,-0.01 -0.01,-0.02 -0.03,-0.02 -0.01,-0.01 -0.02,-0.02 -0.02,-0.02 -0.01,-0.01 -0.02,-0.01 -0.03,-0.02 0,-0.01 0,-0.02 0,-0.03 0,-0.02 0.01,-0.04 0.02,-0.05 0.01,-0.02 0.03,-0.02 0.05,-0.02 0.01,0 0.03,0 0.05,0.01l-0.01 0.04c-0.02,-0.01 -0.03,-0.02 -0.04,-0.02 -0.01,0 -0.02,0.01 -0.03,0.01 0,0.01 -0.01,0.01 -0.01,0.02 0,0.01 0.01,0.02 0.01,0.02 0.01,0.01 0.02,0.01 0.03,0.02 0.01,0.01 0.02,0.01 0.03,0.02 0.01,0 0.02,0.01 0.02,0.02 0.01,0.01 0.01,0.02 0.01,0.03 0,0.03 -0.01,0.05 -0.02,0.06 -0.01,0.01 -0.03,0.01 -0.05,0.01 -0.02,0 -0.04,0 -0.06,-0.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil14",
    d: "M3.29 1.78c0.02,0 0.01,-0.04 -0.01,-0.03 -0.02,0.01 -0.01,0.04 0.01,0.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil14",
    d: "M3.36 1.78c0.02,0 0.01,-0.03 -0.01,-0.03 -0.02,0.01 -0.01,0.04 0.01,0.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil15",
    d: "M3.44 2.46l0 -0.19 -0.06 0 0 0.19c0,0 0.01,-0.01 0.01,-0.01 0.01,-0.01 0.01,-0.01 0.02,-0.01 0.02,-0.01 0.02,0.02 0.03,0.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil15",
    d: "M3.44 1.94c-0.02,0.01 -0.04,0.01 -0.06,0l0 0.14 0.06 0 0 -0.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil14",
    d: "M3.42 2.19c0.02,-0.01 0.01,-0.04 -0.02,-0.03 -0.01,0.01 0,0.04 0.02,0.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil14",
    d: "M3.49 2.19c0.02,0 0.01,-0.03 -0.01,-0.03 -0.02,0.01 -0.01,0.04 0.01,0.03z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil16",
    transform: "matrix(2.37421E-14 -0.852028 1.9936 5.01831E-14 3.29559 2.29694)",
    width: 0.25,
    height: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil15",
    d: "M2.98 1.85c0,-0.02 0.01,-0.04 -0.01,-0.06l0.35 0 0 0.06 -0.34 0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil14",
    d: "M2.71 1.78c0.02,0 0.01,-0.04 -0.01,-0.03 -0.02,0.01 -0.01,0.04 0.01,0.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil14",
    d: "M2.78 1.78c0.02,0 0.01,-0.03 -0.01,-0.03 -0.02,0.01 -0.01,0.04 0.01,0.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil15",
    d: "M2.69 2.52c-0.05,0 -0.11,0 -0.16,0 -0.03,0 -0.05,0.01 -0.08,-0.01 -0.07,-0.03 -0.06,-0.1 -0.06,-0.16l0 -0.31c0,-0.07 -0.01,-0.14 0.05,-0.18 0.02,-0.01 0.04,-0.02 0.07,-0.02 0.05,0 0.11,0 0.16,0 -0.01,-0.02 0,-0.03 0,-0.06 -0.03,0 -0.17,0 -0.19,0.01 -0.06,0 -0.09,0.03 -0.12,0.07 -0.04,0.04 -0.03,0.09 -0.03,0.15l0 0.37c0,0.05 0,0.1 0.04,0.14 0.03,0.04 0.07,0.06 0.12,0.06 0.07,0.01 0.14,0 0.2,0 -0.01,0 -0.02,-0.01 -0.02,-0.02 0,-0.02 0.01,-0.03 0.02,-0.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil17",
    d: "M2.86 2.42c-0.01,-0.01 -0.02,-0.03 -0.03,-0.03 -0.01,0.01 -0.01,0.01 -0.02,0.01 0,0.01 -0.01,0.01 -0.01,0.02 -0.01,0.01 -0.03,0.03 -0.04,0.04l-0.04 0.04c-0.01,0 -0.02,0.02 -0.03,0.02 -0.01,0.01 -0.02,0.02 -0.02,0.04 0,0.01 0.01,0.02 0.02,0.02l0.03 0.03c0,0.01 0.01,0.02 0.02,0.03 0.01,0 0.01,0 0.02,0.01l0.04 0.04c0,0.01 0.01,0.02 0.03,0.02 0.01,0 0.02,-0.01 0.03,-0.02l0.07 -0.07c0,0 0.01,0 0.01,-0.01 0.02,-0.01 0.02,-0.02 0.04,-0.04 0,0 0.01,-0.01 0.01,-0.02 0,-0.01 -0.04,-0.04 -0.05,-0.05 -0.01,-0.01 -0.02,-0.02 -0.03,-0.03 -0.01,-0.01 -0.01,-0.02 -0.02,-0.03 -0.01,-0.01 -0.03,-0.02 -0.03,-0.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil15",
    d: "M2.86 2.42l0 -0.15 -0.06 0 0 0.15c0,-0.01 0.01,-0.01 0.01,-0.02 0.01,0 0.01,0 0.02,-0.01 0.01,0 0.02,0.02 0.03,0.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil15",
    d: "M2.86 1.97c-0.02,0 -0.04,0 -0.06,0l0 0.11 0.06 0 0 -0.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil14",
    d: "M2.83 2.19c0.03,-0.01 0.01,-0.04 -0.01,-0.03 -0.02,0.01 -0.01,0.04 0.01,0.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil14",
    d: "M2.91 2.19c0.02,0 0.01,-0.03 -0.01,-0.03 -0.02,0.01 -0.02,0.04 0.01,0.03z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil16",
    transform: "matrix(2.37421E-14 -0.852028 1.9936 5.01831E-14 2.70527 2.29694)",
    width: 0.25,
    height: 0.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil4",
    transform: "matrix(2.37421E-14 -0.852028 1.9936 5.01831E-14 2.70527 1.30383)",
    width: 0.25,
    height: 0.11
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil15",
    points: "2.85,1.58 2.8,1.58 2.8,1.62 2.85,1.62 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil15",
    points: "2.85,1.46 2.8,1.46 2.8,1.51 2.85,1.51 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil15",
    points: "2.85,1.35 2.8,1.35 2.8,1.4 2.85,1.4 "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil5",
    transform: "matrix(8.87933E-14 -3.18641 3.35255 8.4393E-14 2.82785 1.81659)",
    r: 0.05
  })), /*#__PURE__*/React.createElement("rect", {
    className: "fil4",
    transform: "matrix(2.37421E-14 -0.852028 1.9936 5.01831E-14 3.29559 1.94379)",
    width: 0.25,
    height: 0.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil4",
    transform: "matrix(2.37421E-14 -0.852028 1.9936 5.01831E-14 3.29559 2.64383)",
    width: 0.25,
    height: 0.11
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectDefaultImage);
export default __webpack_public_path__ + "static/media/projectDefaultImage.1528de53d8104e0ba31a58c8fe5cb7e2.svg";
export { ForwardRef as ReactComponent };